// Module
var code = " ";
// Exports
export default code;